const appbasePrefs = '{{APPBASE_PREFERENCES}}';

export default JSON.stringify(appbasePrefs);
